// Render-time localization for business dropdown options.
// Radix <Select> options must be localized at the React render layer (i18nAuto/MutationObserver
// cannot translate Radix ItemText reliably). The stored VALUE stays the French key so the
// backend contract and score logic are unchanged; only the visible label is translated.

export const SIZES = ["Micro-entreprise", "TPE", "PME"];
export const SIZE_LABELS = {
  fr: { "Micro-entreprise": "Micro-entreprise", "TPE": "TPE", "PME": "PME" },
  en: { "Micro-entreprise": "Micro-business", "TPE": "Small business", "PME": "SME" },
  es: { "Micro-entreprise": "Microempresa", "TPE": "Pequeña empresa", "PME": "PYME" },
};

export const GOALS = ["Augmenter ma clientèle", "Augmenter mon chiffre d'affaires", "Fidéliser mes clients", "Réactiver mes anciens clients", "Augmenter le panier moyen", "Améliorer ma réputation", "Obtenir davantage d'avis clients", "Développer ma présence en ligne", "Augmenter la fréquentation", "Remplir mes créneaux / réservations", "Écouler certains stocks", "Développer les ventes récurrentes", "Autre objectif"];
export const GOAL_LABELS = {
  en: {
    "Augmenter ma clientèle": "Grow my customer base", "Augmenter mon chiffre d'affaires": "Grow my revenue",
    "Fidéliser mes clients": "Build customer loyalty", "Réactiver mes anciens clients": "Reactivate former customers",
    "Augmenter le panier moyen": "Increase average basket", "Améliorer ma réputation": "Improve my reputation",
    "Obtenir davantage d'avis clients": "Get more customer reviews", "Développer ma présence en ligne": "Grow my online presence",
    "Augmenter la fréquentation": "Increase footfall", "Remplir mes créneaux / réservations": "Fill my slots / bookings",
    "Écouler certains stocks": "Clear some stock", "Développer les ventes récurrentes": "Grow recurring sales",
    "Autre objectif": "Other goal",
  },
  es: {
    "Augmenter ma clientèle": "Aumentar mi clientela", "Augmenter mon chiffre d'affaires": "Aumentar mi facturación",
    "Fidéliser mes clients": "Fidelizar a mis clientes", "Réactiver mes anciens clients": "Reactivar antiguos clientes",
    "Augmenter le panier moyen": "Aumentar el ticket medio", "Améliorer ma réputation": "Mejorar mi reputación",
    "Obtenir davantage d'avis clients": "Conseguir más reseñas", "Développer ma présence en ligne": "Desarrollar mi presencia online",
    "Augmenter la fréquentation": "Aumentar la afluencia", "Remplir mes créneaux / réservations": "Llenar mis huecos / reservas",
    "Écouler certains stocks": "Liquidar stock", "Développer les ventes récurrentes": "Desarrollar ventas recurrentes",
    "Autre objectif": "Otro objetivo",
  },
};

// [storedValue, frLabel]
export const FREQ = [["jamais", "Jamais"], ["rarement", "Rarement"], ["mensuel", "Mensuelle"], ["hebdomadaire", "Hebdomadaire"], ["quotidien", "Quotidienne"]];
export const FREQ_LABELS = {
  jamais: { fr: "Jamais", en: "Never", es: "Nunca" },
  rarement: { fr: "Rarement", en: "Rarely", es: "Raramente" },
  mensuel: { fr: "Mensuelle", en: "Monthly", es: "Mensual" },
  hebdomadaire: { fr: "Hebdomadaire", en: "Weekly", es: "Semanal" },
  quotidien: { fr: "Quotidienne", en: "Daily", es: "Diaria" },
};

export const PICK_TXT = {
  choose: { fr: "Choisir", en: "Select", es: "Elegir" },
  chooseFam: { fr: "Choisir une famille", en: "Choose a family", es: "Elegir una familia" },
  chooseTrade: { fr: "Choisir un métier", en: "Choose a trade", es: "Elegir un oficio" },
  searchActivity: { fr: "🔎 Rechercher votre activité…", en: "🔎 Search your business…", es: "🔎 Busca tu actividad…" },
};

export const L = (m, lang) => (m && (m[lang] || m.fr)) || "";
export const sizeLabel = (s, lang) => (SIZE_LABELS[lang] || SIZE_LABELS.fr)[s] || s;
export const goalLabel = (g, lang) => (lang === "fr" ? g : (GOAL_LABELS[lang] && GOAL_LABELS[lang][g]) || g);
export const freqLabel = (v, lang) => (FREQ_LABELS[v] && (FREQ_LABELS[v][lang] || FREQ_LABELS[v].fr)) || v;
